// extracted by mini-css-extract-plugin
export default {"table":"StyledTable_table__rRk3J"};